<template>
    <div>testModal</div>
</template>

<script>
    export default {
        name: "TestModal"
    }
</script>

<style scoped>

</style>